import { ComponentPropsWithRef } from 'react';

import Link from '~/common/components/Link';
import HStack from '~/common/components/Stacks/HStack';

type CardProps = ComponentPropsWithRef<typeof HStack> & {
  children?: any;
};

const Card = ({ children, ...props }: Readonly<CardProps>) => {
  return (
    <Link _hover={{ textDecoration: 'none' }}>
      <HStack
        border="1px solid"
        borderColor="gray.300"
        borderRadius={4}
        p={4}
        sx={{ cursor: 'pointer', justifyContent: 'space-evenly' }}
        {...props}
      >
        {children}
      </HStack>
    </Link>
  );
};

export default Card;
